"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledSystem = require("styled-system");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _polished = require("polished");

var _Chip = _interopRequireDefault(require("../Chip/Chip"));

var _system = _interopRequireWildcard(require("../../utils/system"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var propTypes = {
  /**
   * Override or extend the styles applied to the components.
   */
  classes: (0, _propTypes.shape)({
    root: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func]),
    img: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func]),
    text: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func]),
    chip: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func])
  }),

  /**
   * The name of the person in the avatar.
   */
  name: _propTypes.string,

  /**
   * The size of the avatar.
   */
  size: (0, _propTypes.oneOf)(['xs', 'sm', 'md', 'lg']),

  /**
   * The image url of the Avatar.
   */
  src: _propTypes.string,

  /**
   * List of sources to use for different screen resolutions.
   */
  srcSet: _propTypes.string,

  /**
   * Show a chip with the status of the avatar.
   */
  status: (0, _propTypes.oneOf)(['online', 'offline']),

  /**
   * Type of avatar.
   */
  variant: (0, _propTypes.oneOf)(['square', 'rounded', 'circle'])
};
var defaultProps = {
  classes: {
    root: null,
    img: null,
    text: null,
    chip: null
  },
  name: undefined,
  size: 'md',
  src: undefined,
  srcSet: undefined,
  status: undefined,
  variant: 'circle'
};
var AvatarRoot = (0, _system["default"])('div', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['scale'].includes(prop);
  }
})({
  label: 'AvatarRoot'
}, function (_ref) {
  var hasImage = _ref.hasImage,
      currentBg = _ref.currentBg;
  return (0, _css["default"])({
    alignItems: 'center',
    bg: hasImage ? 'transparent' : currentBg,
    color: (0, _polished.readableColor)(currentBg),
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'center',
    overflow: 'hidden',
    position: 'relative',
    userSelect: 'none'
  });
}, (0, _styledSystem.variant)({
  prop: 'scale',
  variants: {
    xs: {
      fontSize: 'md',
      height: 10,
      width: 10
    },
    sm: {
      fontSize: 'xl',
      height: 12,
      width: 12
    },
    md: {
      fontSize: 'xl',
      height: 16,
      width: 16
    },
    lg: {
      fontSize: '3xl',
      height: 20,
      width: 20
    }
  }
}), (0, _styledSystem.variant)({
  variants: {
    square: {},
    rounded: {
      borderRadius: 'md'
    },
    circle: {
      borderRadius: 'full'
    }
  }
}), (0, _system.classesStyles)('root'));
var AvatarImg = (0, _base["default"])("img", process.env.NODE_ENV === "production" ? {
  target: "e5y7uph1"
} : {
  target: "e5y7uph1",
  label: "AvatarImg"
})("width:100%;height:100%;object-fit:cover;", (0, _system.classesStyles)('img'));
var AvatarText = (0, _base["default"])("div", process.env.NODE_ENV === "production" ? {
  target: "e5y7uph0"
} : {
  target: "e5y7uph0",
  label: "AvatarText"
})((0, _css["default"])({
  fontFamily: 'body',
  fontWeight: 'medium',
  textAlign: 'center',
  textTransform: 'uppercase'
}), (0, _system.classesStyles)('text'));

var initials = function initials(name) {
  if (!name) return '';

  var _name$split = name.split(' '),
      _name$split2 = _slicedToArray(_name$split, 2),
      firstName = _name$split2[0],
      lastName = _name$split2[1];

  return firstName && lastName ? "".concat(firstName.charAt(0)).concat(lastName.charAt(0)) : firstName.charAt(0);
};

var Component = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var classes = _ref2.classes,
      name = _ref2.name,
      size = _ref2.size,
      src = _ref2.src,
      srcSet = _ref2.srcSet,
      status = _ref2.status,
      cVariant = _ref2.variant,
      props = _objectWithoutProperties(_ref2, ["classes", "name", "size", "src", "srcSet", "status", "variant"]);

  var _useRef = (0, _react.useRef)((0, _polished.hsla)(Math.floor(Math.random() * 360), 1, 0.4, 0.85)),
      bg = _useRef.current;

  var getAvatar = function getAvatar() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(AvatarRoot, _objectSpread(_objectSpread({
      ref: ref
    }, props), {}, {
      classes: classes,
      scale: size,
      variant: cVariant,
      hasImage: src || srcSet,
      currentBg: bg,
      children: src || srcSet ? /*#__PURE__*/(0, _jsxRuntime.jsx)(AvatarImg, {
        src: src,
        srcSet: srcSet,
        alt: name,
        classes: classes
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(AvatarText, {
        classes: classes,
        children: initials(name)
      })
    }));
  };

  var chipClasses = {
    chip: function chip(innerProps) {
      return (0, _css["default"])(_objectSpread({
        bg: status === 'online' ? 'success' : 'gray.400',
        border: '2px',
        borderColor: 'white',
        height: '16px',
        minWidth: '16px'
      }, (0, _system.classesStyles)('chip')(_objectSpread(_objectSpread({}, innerProps), {}, {
        classes: classes
      }))))(innerProps);
    }
  };
  return status ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip["default"], {
    position: "bottomRight",
    overlap: cVariant === 'circle' ? 'circle' : 'square',
    classes: chipClasses,
    pulse: true,
    children: getAvatar()
  }) : getAvatar();
});
Component.displayName = 'Avatar';
Component.propTypes = propTypes;
Component.defaultProps = defaultProps;
var _default = Component;
exports["default"] = _default;

//# sourceMappingURL=Avatar.js.map